import {
    CmtItem,
    CmtItemTop,
    UserAvatar,
    Username,
    CmtItemBottom,
    CmtContent,
    CmtItemBody,
    CmtItemBottomLeft,
    LikeButton,
    LikeIc,
    RelplyButton,
    CommentIc,
    CmtItemBottomRight,
    ReplyTotal,
    TimeAgo
} from './commentItemElements'
import { useState } from "react"
import moment from 'moment'
import CommentForm from '../commentForm'
import { useDispatch, useSelector } from 'react-redux'
import { openFormLogin } from '../../store/reducer/authFormSlice'
import 'moment/locale/vi';

moment.locale('vi')

const CommentItem = ({comment, newsId, type, parentId}) => {
    const [reply, setReply] = useState(false)
    const dispatch = useDispatch()
    const { user, socket } = useSelector(state => state.user)
    
    const handleLikeOrDislike = cmtId => {
        if(Object.keys(user).length === 0) return dispatch(openFormLogin)
        socket.emit('likeOrDislikeComment', { cmtId, userId: user._id, newsId })
    }

    const showReplyForm = () => {
        setReply(!reply)
    }

    const closeReplyForm = () => {
        setReply(false)
    }
    return (
        <CmtItem type={type}>
            <CmtItemTop>
                <UserAvatar title={comment.userId.username} src={comment.userId?.avatar} alt={comment.userId.username} />
                <CmtItemBody>
                    <Username title={comment.userId.username}>{comment.userId.username}</Username>
                    <CmtContent>{comment.text}</CmtContent>
                </CmtItemBody>
            </CmtItemTop>
            <CmtItemBottom>
                <CmtItemBottomLeft>
                    <LikeButton className={comment.likes.includes(user._id) && 'active'} onClick={() => handleLikeOrDislike(comment._id)}><LikeIc />{comment.likes.length}</LikeButton>
                    <RelplyButton onClick={showReplyForm}><CommentIc />Trả lời</RelplyButton>
                </CmtItemBottomLeft>
                <CmtItemBottomRight>
                    {type !=='reply' && <ReplyTotal>{comment.replies} Trả lời</ReplyTotal>}
                    <TimeAgo>{moment(comment.createdAt).fromNow()}</TimeAgo>
                </CmtItemBottomRight>
            </CmtItemBottom>
            {reply && <CommentForm newsId={newsId} closeReplyForm={closeReplyForm} reply parentId={parentId ? parentId :comment._id} username={comment.userId.username} />}
        </CmtItem>
    )
}

export default CommentItem
